// extracted by mini-css-extract-plugin
export var description = "pages-__DisputeRide-module___description";
export var details = "pages-__DisputeRide-module___details";
export var disclaimer = "pages-__DisputeRide-module___disclaimer";
export var otherLabel = "pages-__DisputeRide-module___otherLabel";
export var otherReason = "pages-__DisputeRide-module___otherReason";